export default function getResource(label, vars = []) {
    const resources = {
        errorDescriptionLine1: 'Désolé, la page que vous cherchez est introuvable.',
        errorDescriptionLine2: 'Veuillez revenir plus tard.'
    };

    return resources[label];
}
